import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=515c4f5c&scoped=true&"
import script from "./sales.vue?vue&type=script&lang=js&"
export * from "./sales.vue?vue&type=script&lang=js&"
import style0 from "./sales.styl?vue&type=style&index=0&id=515c4f5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c4f5c",
  null
  
)

export default component.exports